/* global URL */

const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the add video component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Videos} defines the Videos resource
 */
app.directive('addVideo', ['Application', 'Authorization', 'Videos', 'LinkedVideoData', 'S3Uploads', 'Upload', 'Transcode', 'GoogleExport', 'ErrorReporting', '$timeout', '$sce', '$translate', '$http', function(Application, Authorization, Videos, LinkedVideoData, S3Uploads, Upload, Transcode, GoogleExport, ErrorReporting, $timeout, $sce, $translate, $http) {
    return {
      restrict: 'E',
      scope: {
        video: '=',
        useGenerativeChosen: '=',
        contentId: '@',
        reset: '=',
        presentation: '=',
      },
      template: require('../../../templates/directives/cms/add-video.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.translations = {};
          self.date = new Date();
          self.currentUser = Authorization.getAuthToken().user;
          self.trackState = Application.trackState.get();
          self.generativeAIEnabled = Application.features.flags().enable_generative_ai;
          var colorList = Application.colors.get();
          self.brandColor = colorList ? colorList[0] : '#00BCF1';
          self.stopProp = function(evt) {
            evt.stopPropagation();
          }
          self.chooseUseGenerativeAI = function(bool) {
            if (bool === true || bool === 'true') {
              $scope.video.use_generative_ai = true;
            } else {
              $scope.video.use_generative_ai = false;
            }
          }
          self.allowDrive = function() {
            return Authorization.getAuthToken() && Authorization.getAuthToken().company && Authorization.getAuthToken().company['google_drive'];
          };
          self.uploaderId = 'video-upload';
          self.recordingType = '';
          self.recordingTypeCopy = {
            'video-recording': 'Webcam',
            'screen-recording': 'Screen',
            'screen-recording-no-audio': 'Screen with no Audio',
            'screen-video-recording': 'Webcam and Screen'
          };
          self.recordingstarted = $scope.recordingstarted;
          self.recordedBlob = null;
          self.loadingBar = false;
          self.type = 'none';
          self.isPlaying = false;
          self.replaceFile = false;
          
          var makeDuration = function(link) {
            var video = document.createElement('video');
            var link = $sce.trustAsResourceUrl(link);
            video.setAttribute('src', link);

            var wait = function() {
              setTimeout(function() {
                if (video.readyState < 1) {
                  wait();
                  return;
                }
                $scope.video.duration = Math.round(parseInt(video.duration, 10));
              }, 100);
            };

            if (video.readyState < 1) {
              wait();
              return;
            }
            $scope.video.duration = Math.round(parseInt(video.duration, 10));
          };

          self.setLink = function(keyEvent, bypass) {
            var editing = !$scope.video._id;
            if (!keyEvent && !bypass) {
              return;
            }
            if (keyEvent && keyEvent.which !== 13 || keyEvent && bypass) {
              return;
            }

            var link = self.tempLink;
            var regex = /(youtube)\.com\/watch\?v=([A-Za-z0-9_-]+)|(vimeo)\.com\/([0-9]+)|(youtu)\.be\/([A-Za-z0-9_-]+)/i;
            var regexVimeoEdit = /(youtube)\.com\/watch\?v=([A-Za-z0-9_-]+)|(vimeo)\.com\/video\/([0-9]+)/i;
            var matches = regex.exec(link);

            if (!matches && editing) {
              matches = regexVimeoEdit.exec(link);
            }

            if (matches) {
              var type = matches[1] || matches[5] ? 'youtube' : 'vimeo';
              var idIdx;
              if (matches[1]) {
                idIdx = 2;
              }
              if (matches[3]) {
                idIdx = 4;
              }
              if (matches[5]) {
                idIdx = 6;
              }
              var id = matches[idIdx];

              var setVideo = function(data) {
                var video = $scope.video;
                video.link = link;
                video.source = type;
                video.source_id = id;
                video.title = data.title;
                video.description = data.description;
                video.video_type = 'video/' + type;
                if (data.duration) {
                  video.duration = data.duration;
                }
                self.videoSource = type;
                self.videoSourceId = id;
              };
              LinkedVideoData.retrieve(id, type).then(function(data) {
                setVideo(data);
              }).catch(function(err) {
                if (type === 'vimeo' && err && err.status === 404) {
                  var url = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + id;
                  var req = {
                    method: 'GET',
                    url: url,
                    headers: {
                      'Remove-auth': true
                    }
                  };
                  $http(req)
                  .then(function(results) {
                    setVideo(results.data);
                  }).catch(function(err) {
                    Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.check_private'], duration: 12});
                  });
                  return;
                }
                Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.check_private'], duration: 12});
              });
            } else {
              $scope.video.link = link;
              $scope.video.source = 'remote';
              self.videoSource = 'remote';
              $scope.video.video_type = 'video/mp4';
              makeDuration(link);
            }
            self.tempLink = '';
            self.updatingLink = false;
          };

          self.browseFile = function() {
            document.getElementById(self.uploaderId).click();
          };

          $scope.$watch('addVideo.file', function(newVal, oldVal) {
            if (newVal && !newVal.$error) {
              self.onVideoSelect(self.file);
            }
          });

          var setAfterCustom = function(video, s3ObjectKey, job, google) {
            $scope.video.source = 'custom';
            if ($scope.presentation) {
              $scope.video.link = video.link;
              $scope.video.job = job;
              $scope.video.fileName = self.filename;
              $scope.video.transcoding = true;
              self.loadingBar = false;
              self.loaded = true;
              return;
            }
            makeDuration(video.link);
            $scope.video.link = video.link;
            $scope.video._id = video._id;
            $scope.video.transcoding = true;
            $scope.video.draft = true;
            self.loadingBar = false;
            self.loaded = true;
            var contentid = video._id;
            var subcontentid = '';
            var content_type = 'video';
            if (self.trackState) {
              Application.messaging.clearMessages('trackstate');
              $timeout(function() {
                Application.messaging.addMessage({type: '', text: self.translations['edit.videos.save_add'], trackstate: true, link: '/edit/tracks/' + self.trackState.track});
              }, 1);
              contentid = self.trackState.track;
              subcontentid = video._id;
              content_type = 'track';
            }

            if (google) {
              return;
            }

            /// send heywatch job
            Transcode.transcodeJob({s3ObjectKey: s3ObjectKey, content_type: content_type, contentid: contentid, subcontentid: subcontentid}, function(data) {
            }, function(error) {
              Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
            });
          };

          self.googleSelect = function(url, token, name, mimeType, sizeBytes) {
            self.filename = name;
            var newVideo = {
              user: self.currentUser._id,
              link: 'transcoding',
              transcoding: true,
              source: 'custom',
              title: 'Title',
              type: 'video',
              approved: false,
              draft: true,
              name: name,
              mimeType: mimeType,
              sizeBytes: sizeBytes
            };
            self.driveUploading = true;
            GoogleExport.videoExport({url: url, token: token, video: newVideo}).$promise
            .then(function(data) {
              setAfterCustom(data.video, null, data.job, true);
              self.driveUploading = false;
            }).catch(function(error) {
              ErrorReporting.send({
                message: 'Error in drive video upload request. User (' + self.currentUser._id + ') in company (' + self.currentUser.company + ').',
                context: error
              });
              self.driveUploading = false;
              if (error && error.data && error.data.error && error.data.error.error && error.data.error.error.errors && error.data.error.error.errors[0] && error.data.error.error.errors[0].reason && error.data.error.error.errors[0].reason == 'domainPolicy') {
                Application.messaging.addMessage({type: 'error', text: self.translations['edit.files.admin_disabled_google'], duration: 6});
                return;
              }
              Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.drive_upload_issue'], duration: 6});
            });
          };

          self.onVideoSelect = function(file) {
            if (file.size > 2048000000) {
              Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.1024_limit'], duration: 5});
              return;
            }

            self.filename = file.name;
            $translate(
                'edit.video.beingTranscoded', {filename: self.filename}).then(function(translations) {
              self.translationBeingTranscoded = translations;
            });

            var newVideo = {
              user: self.currentUser._id,
              link: 'transcoding',
              transcoding: true,
              source: 'custom',
              title: 'Title',
              type: 'video',
              approved: false
            };

            S3Uploads.videoPolicy({fileName: file.name, contentType: file.type}, function(data) {
              var cloudFrontLink = data.CloudFrontLink;
              var s3ObjectKey = data.Key;
              var FileName = data.FileName;
              Upload.upload({
                url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
                headers: {'Remove-auth': 'yes'},
                method: 'POST',
                data: {
                  key: data.Key,
                  'Content-Type': data.ContentType,
                  AWSAccessKeyId: data.AWSAccessKeyId,
                  'success_action_status': '201',
                  policy: data.S3Policy,
                  signature: data.S3Signature
                },
                file: file
              }).progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
                self.loadingBar = true;
                self.loadingPercent = percent;
                self.progress = {'width': parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10) + '%'};
              }).success(function(data) {
                if ($scope.presentation) {
                  Transcode.transcodeJob({s3ObjectKey: s3ObjectKey, content_type: 'presentation', contentid: $scope.presentation}, function(data) {
                    $scope.video.link = cloudFrontLink;
                    $scope.video.job = data;
                    $scope.video.fileName = self.filename;
                    $scope.video.transcoding = true;
                    self.loadingBar = false;
                    self.loaded = true;
                  }, function(error) {
                    Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
                  });
                  return;
                }

                if (self.replaceFile) {
                  $scope.video.link = cloudFrontLink
                  $scope.video.draft = true;
                  Videos.update({subresource: $scope.video._id, fields: "link"}, {link: $scope.video.link}).$promise
                  .then(video => {
                    setAfterCustom(video, s3ObjectKey);
                  })
                  self.replaceFile = false;
                  return;
                }

                newVideo.link = cloudFrontLink;
                newVideo.draft = true;
                newVideo.use_generative_ai = $scope.video.use_generative_ai;
                Videos.create(newVideo).$promise
                .then(function(video) {
                  setAfterCustom(video, s3ObjectKey);
                });
              }).catch(function(error) {
                Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.contents_error'], duration: 5});
              });
            }, function(error) {
              Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
            });
          };

          self.showVideo = function(type) {
            if (!$scope.video || !$scope.video.link) {
              return false;
            }

            if (type === 'custom') {
              if ($scope.video.source !== 'custom' && $scope.video.source !== 'remote') {
                return false;
              }

              if (self.creatingVideo) {
                return false;
              }

              return true;
            }

            if ($scope.video.source !== 'vimeo' && $scope.video.source !== 'youtube') {
              return false;
            }

            if (self.updatingLink) {
              return false;
            }

            return true;
          };

          self.updateLink = function() {
            self.oldVideo = JSON.parse(JSON.stringify($scope.video));

            var video = $scope.video;
            video.link = null;
            video.source = null;
            video.source_id = null;
            video.title = null;
            video.description = null;
            video.video_type = null;
            self.videoSource = null;
            self.videoSourceId = null;

            self.updatingLink = true;
          };

          self.undoLink = function() {
            var video = $scope.video;
            var oldVideo = self.oldVideo;

            video.link = oldVideo.link.slice(0);
            video.source = oldVideo.source.slice(0);
            video.source_id = oldVideo.source_id.slice(0);
            video.title = oldVideo.title.slice(0);
            video.description = oldVideo.description.slice(0);

            video.video_type = 'link';
            self.videoSource = video.source;
            self.videoSourceId = video.source_id;

            self.oldVideo = null;
            self.updatingLink = false;
          };

          $scope.$watch('reset', function(newVal, oldVal) {
            if (newVal) {
              self.type = null;
              $scope.reset = false;
            }
          });
          
          self.initialize = function() {
            if (!$scope.video && $scope.contentId) {
              self.loading = true;
              Videos.get({subresource: $scope.contentId, fields: 'link,link_name,youtube_id,images,source,source_id,transcoding,createdAt'}).$promise
                  .then(function(data) {
                    self.video = data;
                    self.date = data.createdAt;
                    self.loading = false;
                  })
                  .catch(function(err) {
                    self.loading = false;
                    console.log('Error in retrieving Video.');
                  });
            } else if (!$scope.video) {
              console.log('Error: No data provided to add-video directive.');
              return;
            }
            // set video parameters to display video
            if ($scope.video.source === 'vimeo' || $scope.video.source === 'youtube') {
              self.type = 'link';
              self.videoSource = $scope.video.source;
              self.videoSourceId = $scope.video.source_id;
            } else if ($scope.video.source === 'remote' || $scope.video.source === 'custom') {
              self.type = 'custom';
              self.videoSource = $scope.video.source;
            };
          };

          $translate([
            'edit.videos.check_private',
            'edit.videos.save_add',
            'edit.files.admin_disabled_google',
            'edit.videos.drive_upload_issue',
            'edit.videos.1024_limit',
            'edit.videos.contents_error'
          ]).then(function(translations) {
            self.translations = translations;
          });

          var init = false;

          if (!$scope.video && !$scope.contentId) {
            $scope.$watch('video', function(newVal, oldVal) {
              if (!newVal || newVal === oldVal || init) {
                return;
              }

              self.video = $scope.video;
              self.initialize();
            });
            $scope.$watch('contentId', function(newVal, oldVal) {
              if (!newVal || newVal === oldVal || init) {
                return;
              }

              init = true;
              self.initialize();
            });
            return;
          }
          self.initialize();

        }],
      controllerAs: 'addVideo'
    };
  }]);


